module.exports = __webpack_public_path__ + "img/more-icon.7ed49818.svg";